import type { SyntheticEvent } from "react";
import type { Shipment } from "api";
import { CARRIER_CUBE, carrierLabel, carrierLogoUrl } from "./shipments.model";

type CarrierLogoProps = {
  shipment: Shipment;
  className: string;
  size: number;
};

/** A carrier missing from the icon set gets the generic cube, once — never a broken image. */
export const carrierLogoFallback = (event: SyntheticEvent<HTMLImageElement>) => {
  const image = event.currentTarget;

  if (image.dataset.fallback !== undefined) return;

  image.dataset.fallback = "";
  image.src = CARRIER_CUBE;
};

/** The carrier's logo where the design draws one: the list row, the shipment page, the arrivals card. */
export const CarrierLogo = ({ shipment, className, size }: CarrierLogoProps) => (
  <img
    // A new source must get its own chance to load, not inherit the old fallback.
    key={carrierLogoUrl(shipment)}
    className={className}
    src={carrierLogoUrl(shipment)}
    alt={shipment.carrier_scac ? carrierLabel(shipment) : ""}
    width={size}
    height={size}
    loading="lazy"
    onError={carrierLogoFallback}
  />
);
